export default {
  ADD_REQUISITES (state, docs) {
    state.requisites = docs
  },
  ADD_NEW_REQUISITES (state, doc) {
    state.requisites.push(doc)
  },
  DELETE_REQUISITES (state, id) {
    state.requisites = state.requisites.filter(d => d.id !== id)
  },
  UPDATE_REQUISITE (state, requisite) {
    Object.assign(state.requisites.find(r => r.id === requisite.id), requisite)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/requisites.js